import '../input/button-input';

import { LitElement } from 'lit';
import { customElement, state } from 'lit/decorators.js';

@customElement('sticky-nav')
export class StickyNav extends LitElement {

	// Props
	@state()
	_slotNodes: Node[] = [];

	// Lifecycle Hooks

	firstUpdated() {

		// add classes
		this.classList.add('MainNav','MainNav--sticky');

		// slots
		const slot: HTMLElement | null = this.querySelector('[slot="body"]');
		if (slot) {
			this._slotNodes = Array.from(slot.childNodes);
			this._slotNodes.forEach((node) => {
				this.appendChild(node);
			});
		}

		// observer
		document.addEventListener('navvisible', () => {
			this.classList.remove('is-active');
		});
		document.addEventListener('navhidden', () => {
			this.classList.add('is-active');
		});
		window.addEventListener('wheel', (e: WheelEvent) => {
			if (e.deltaY < 0) {
				this.classList.add('is-visible');
				document.dispatchEvent(new Event('navstuck'));
			} else if (e.deltaY > 0) {
				this.classList.remove('is-visible');
				document.dispatchEvent(new Event('navunstuck'));
			}
		});
	}

	createRenderRoot() { 
		return this;
	}

}